<template>
  <div class="home">
    <v-carousel
      hide-delimiters
      hide-arrows
      :left-control-icon="false"
      :right-control-icon="false"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <div class="container">
      <backtospeisekarte></backtospeisekarte>
    </div>
    <v-card>
      <v-card-title class="display-3">
        Ramen
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
import Backtospeisekarte from './Backtospeisekarte.vue';
export default {
  components: { Backtospeisekarte },
  name: 'Ramen',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/ramenmithintergrund.jpg'),
        },
        {
          src: require('../assets/images/ramenoben.jpg'),
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: 'R1',
          speise: 'Nudelsuppe mit Gemüse',
          allergene: '(A, C, F, N, E, G, O)',
          preis: '10,50 €',
        },
        {
          nummer: 'R2',
          speise: 'Nudelsuppe mit Meeresfrüchten oder Garnelen und Gemüse',
          allergene: '(A, F, R, D, E, G, B, C, O)',
          preis: '12,80 €',
        },
        {
          nummer: 'R3',
          speise: 'Nudelsuppe mit Hühner- oder Rindfleisch und Gemüse',
          allergene: '(A,F)',
          preis: '11,90 €',
        },
        {
          nummer: 'R4',
          speise: 'Nudelsuppe mit Tofu und Gemüse',
          allergene: '(A, F, E, N, G, C, O)',
          preis: '11,90 €',
        },
        {
          nummer: 'R5',
          speise: 'Nudelsuppe mit knuspriger Ente und Gemüse',
          allergene: '(A, C, E, F, N, O)',
          preis: '13,30 €',
        },
        // {
        //   nummer: 'R11',
        //   speise: 'Nudelsuppe mit faschiertem Fleisch und Gemüse',
        //   allergene: '(A, C, E, F, N, O)',
        //   preis: '11,40 €',
        // },
        {
          nummer: 'R6',
          speise: 'Udonsuppe mit Gemüse',
          allergene: '(A, C, E, F, N, O)',
          preis: '10,50 €',
        },
        {
          nummer: 'R7',
          speise: 'Udonsuppe mit Meeresfrüchten oder Garnelen und Gemüse',
          allergene: '(A, F, R, D, E, G, B, C, O)',
          preis: '12,80 €',
        },
        {
          nummer: 'R8',
          speise: 'Udonsuppe mit Hühner- oder Rindfleisch und Gemüse',
          allergene: '(A,F)',
          preis: '11,90 €',
        },
        {
          nummer: 'R9',
          speise: 'Udonsuppe mit Tofu und Gemüse',
          allergene: '(A, F, E, N, G, C, O)',
          preis: '11,90 €',
        },
        {
          nummer: 'R10',
          speise: 'Udonsuppe mit knuspriger Ente und Gemüse',
          allergene: '(A, C, E, F, N, O)',
          preis: '13,30 €',
        },
        // {
        //   nummer: 'R12',
        //   speise: 'Udonsuppe mit faschiertem Fleisch und Gemüse',
        //   allergene: '(A, C, E, F, N, O)',
        //   preis: '11,40 €',
        // },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
